import {
  USER_INVITED,
  USER_TRANSFERRED,
  TRANSFER_ACCEPTED,
  USER_REMOVED
} from "constants/account/users";

export const inviteUser = ({ email, name, role }) => ({
  type: USER_INVITED,
  payload: { email, name, role }
});

export const transferUser = ({ email, name, role }) => ({
  type: USER_TRANSFERRED,
  payload: { email, name, role }
});

export const acceptTransfer = ({ accountId }) => ({
  type: TRANSFER_ACCEPTED,
  payload: { accountId }
});

export const removeUser = ({ id }) => ({
  type: USER_REMOVED,
  payload: { id }
});
